export function reforecastStartMonthString(monthIdx: any): string {
    if(typeof monthIdx !== "number") {
        return "Unknown Update";
    }

    return `Reforecast Month ${monthIdx + 1}`;
}